export const METRUYENCHU_SELECTORS = {
  metadata: {
    title: "h1[itemprop='name']",
    author: "[itemprop='author']",
    description: ["div.book-info-text [itemprop='description']", "div.book-info-text .desc"],
    cover: "[itemprop='image']",
    genres: ".li--genres a[href*='/the-loai/']",
    statusFull: ".label-status.label-full",
    statusOngoing: [".label-status.label-hot", ".label-status.label-ongoing"],
    bookIdInput: "input[name='bid']",
    pagingPageFn: "[onclick^='page(']",
    infoListItem: "div.book-info-text ul li",
  },
  toc: {
    listItem: "#chapter-list ul li a",
    jsonListItem: "ul:not(ul ul) > li > a",
  },
  chapter: {
    title: ".chapter-title h2.current-chapter",
    body: "#vungdoc",
    stripNavSelectors: [
      ".chapter-nav",
      ".chapter-nav-top",
      ".chapter-nav-bottom",
      ".chapter_wrap",
    ],
    navTextRegex: /^(Chương trước|Chương tiếp|Tải Ebook|《|》)/i,
  },
} as const;
